import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import { useSelector } from 'react-redux';
import DetailProduct from './DetailProduct';
import DrinksScreens from './drinks';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [carnte, setcarnte] = useState(false);
    const [dataDrink, setdataDrink] = useState(false);
    const [showDrinks, setshowDrinks] = useState(false);
    const [showPicadera, setshowPicadera] = useState(false);
    const [showMofongos, setshowMofongos] = useState(false);
    const [showMariscos, setshowMariscos] = useState(false);
    const [showCarnes, setshowCarnes] = useState(false);
    const [showEntradas, setshowEntradas] = useState(false);
    const [showEnsaladas, setshowEnsaladas] = useState(false);
    const [showDesayunos, setshowDesayunos] = useState(false);
    const [showChofan, setshowChofan] = useState(false);
    const [showCocteles, setshowCocteles] = useState(false);
    const [showSandwiches, setshowSandwiches] = useState(false);
    const [showAcompanantes, setshowAcompanantes] = useState(false);
    const [showCombos, setshowCombos] = useState(false);
    const [showCafe, setshowCafe] = useState(false);
    const [showBatidos, setshowBatidos] = useState(false);
    const [showJugos, setshowJugos] = useState(false);
    const [showPostres, setshowPostres] = useState(false);
    const [showSopas, setshowSopas] = useState(false);
    const [showPastas, setshowPastas] = useState(false);




     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
                if (item.id === 479) {
                    setdrinks(item);
                    
                }
               
                 if (item.id === 469) {
                    setcarnte(item);
                 }
                
                if(item.id === 840) {
                    setshowPicadera(item);
                }
                if(item.id === 838) {
                    setshowMofongos(item);
                }
                if(item.id === 837) {
                    setshowMariscos(item);
                }
                if(item.id === 836) {
                    setshowCarnes(item);
                }
                if(item.id === 835) {
                    setshowEntradas(item);
                }
                if(item.id === 846) {
                    setshowEnsaladas(item);
                }
                if(item.id === 847) {
                    setshowDesayunos(item);
                }
                if(item.id === 844) {
                    setshowChofan(item);
                }
                if(item.id === 851) {
                    setshowCocteles(item);
                }
                if(item.id === 841) {
                    setshowSandwiches(item);
                }
                if(item.id === 849) {
                    setshowAcompanantes(item);
                }
                
                if(item.id === 845) {
                    setshowCombos(item);
                }
                if(item.id === 852) {
                    setshowCafe(item);
                }
                if(item.id === 851) {
                    setshowBatidos(item);
                }
                if(item.id === 851) {
                    setshowJugos(item);
                }
                if(item.id === 850) {
                    setshowPostres(item);
                }
                if(item.id === 842) {
                    setshowSopas(item);
                }
                if(item.id === 839) {
                    setshowPastas(item);
                }
            });
      }, [menus]);
    
    
    
     useEffect(() => {
         if (drinks) {
             drinks.menus.map((item) => {
                 if (item.id === 4374) {
                     setdataDrink(item)
                     
                
               }
           })
       }
     }, [drinks]);
    
    
    useEffect(() => {
        console.log(goHomeInit, 'q mas qlq')
         setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
        setshowCategories(false)
        setShowDetailProduct(false)
    }, [goHomeInit]);
    


    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            getInitData();

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    

    return (
         <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showImageTop={true} setShowSpecials={() => {
            setShowSpecials(true)
            }} goCategories={() => {
                setShowListProduct(true)
                setdishs(showCocteles)
        }}>
                <div>
                    
                    <img
                        style={{
                            width: 490,
                            height: 100,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            position: 'relative',
                            marginTop: -10,
                            
                        }}
                        src={require('./assets/logo.png')}
                    />


                    <img
                        style={{
                            width: 490,
                            height: 100,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            position: 'relative',
                            marginTop: 40,
                            
                        }}
                        src={require('./assets/menu.png')}
                    />
                
                   
                    <div
                        style={{
                            width: '90%',
                            margin: '14px auto 0',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16,
                            position: 'relative',
                            zIndex: 100
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginBottom: 20 }}>
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showPicadera)
                                }}
                                src={require('./assets/rowone/1-PICADERA.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showMofongos)
                                }}
                                src={require('./assets/rowone/2-MOFONGOS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showMariscos)
                                }}
                                src={require('./assets/rowone/3-MARISCOS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showCarnes)
                                }}
                                src={require('./assets/rowone/4-CARNES.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        </div>
                        
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showEntradas)
                                }}
                                src={require('./assets/rowone/5-ENTRADAS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showEnsaladas)
                                }}
                                src={require('./assets/rowone/6-ENSALADAS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showDesayunos)
                                }}
                                src={require('./assets/rowone/7-DESAYUNOS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showChofan)
                                }}
                                src={require('./assets/rowone/8-CHOFAN.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        </div>
                    </div>

                   
                </div>
                
                <div style={{ width: '100%', position: 'relative'}}>
                     <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{
                        width: '90%',
                        height: 212,
                            borderRadius: 14,
                            objectFit: 'contain',
                            marginTop: 30,
                        marginBottom : 20
                        }}
                        src={require('./assets/bannerhome.mp4')}
                    />
                    
                </div>

                <div
                        style={{
                            width: '90%',
                            margin: '20px auto 0',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16,
                            position: 'relative',
                            zIndex: 100
                        }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginBottom: 20 }}>
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showCocteles)
                            }}
                            src={require('./assets/rowone/9-BEBIDAS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showSandwiches)
                            }}
                            src={require('./assets/rowone/10-SANDWICHES.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showAcompanantes)
                            }}
                            src={require('./assets/rowone/11-ACOMPANANTES.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showCombos)
                            }}
                            src={require('./assets/rowone/12-COMBOS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showCafe)
                            }}
                            src={require('./assets/rowone/13-CAFE.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showSopas)
                            }}
                            src={require('./assets/rowone/SOPAS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showPastas)
                            }}
                            src={require('./assets/rowone/PASTAS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showPostres)
                            }}
                            src={require('./assets/rowone/16-POSTRES.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                    </div>
                    </div>

           
            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
                {showBar && <BarScreen setShowBar={setShowBar} />}
                   {showDrinks && <DrinksScreens setShowListProduct={setshowDrinks} setShowHappy={setshowCategories} />}
            

            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}
            
           
      
            
        </LayoutContent>
        </div>
    );
}

export default Index;